import React, { Component } from "react";

import ReCAPTCHA from "react-google-recaptcha";

import AnmeldungService from "../services/AnmeldungService";
import CenteredLoader from "./CenteredLoader";

export default class AnmeldungTrainerSubmit extends Component {

    state = {
        isDatenschutzAccepted: false,
        isSaving: false,
        errorMessage: null,
        captcha: null,
    }

    recaptchaRef = React.createRef();

    onDatenschutToggle = (e) => {
        this.setState(prevState => ({
            isDatenschutzAccepted: !prevState.isDatenschutzAccepted
        }));
    }

    onCaptchaChange = (captchaResult) => {
        this.setState({ captcha: captchaResult });
    }

    onFinish = (e) => {
        console.log("Speichere Anmeldedaten auf Server...");
        this.setState({ isSaving: true });

        const request = {
            anmeldezeitpunkt: new Date(),
            email: this.props.allgemeinData.inputMail.value,
            captcha: this.state.captcha,
            teilnehmer: this.props.sportlerList.map(s => {
                return {
                    disziplinId: Number(s.wettbewerb.value),
                    vorname: s.vorname,
                    nachname: s.nachname,
                    geschlecht: s.geschlecht.value,
                    jahrgang: Number(s.jahrgang),
                    verein: this.props.allgemeinData.inputVerein.value,
                    verband: this.props.allgemeinData.inputVerband.value,
                    startpass: s.startpass
                };
            })
        }

        const eventId = Number(this.props.eventId);

        this.setState({ isSaving: true, errorMessage: null });

        AnmeldungService.storeAnmeldung(eventId, request).then(res => {
            this.props.onSuccess();
        }).catch(err => {
            this.setState({ errorMessage: err.response.data, isSaving: false, captcha: null })
            this.recaptchaRef.current.reset();
        })

    }

    render() {
        const allgemeinData = this.props.allgemeinData;
        const sportlerList = this.props.sportlerList;
        const mitStartpass = this.props.mitStartpass;

        return (

            <div className="row">
                <div className="col-md-12">
                    <form className="jh-content-form">

                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label htmlFor="inputMail">E-Mail-Adresse</label>
                                <p>{allgemeinData.inputMail.value}</p>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-8">
                                <label htmlFor="inputVerein">Verein/Team</label>
                                <p>{allgemeinData.inputVerein.value}</p>
                            </div>
                            <div className="form-group col-md-4">
                                <label htmlFor="inputVerband">Verband</label>
                                <p>{allgemeinData.inputVerband.value || "-"}</p>
                            </div>
                        </div>

                        <div className="d-none d-md-block">
                            <div>
                                <div>
                                    <div className="row jh-list-group-header jh-list-group-row">
                                        <div className="col-md-1">#</div>
                                        <div className="col-md-5">Sportler</div>
                                        <div className="col-md-2">Jahrgang</div>
                                        <div className="col-md-2">Wettbewerb</div>
                                        <div className="col-md-2">{mitStartpass && "Startpass"}</div>
                                    </div>
                                </div>
                                {sportlerList.map((s, idx) => {
                                    return (<div key={idx}>
                                        <div className={"row jh-list-group-row" + (idx % 2 === 0 ? " jh-striped" : "")}>
                                            <div className="col-md-1">{idx + 1}</div>
                                            <div className="col-md-5" style={{ lineHeight: 1.2 }}>{s.vorname} {s.nachname} ({s.geschlecht.label})</div>
                                            <div className="col-md-2">{s.jahrgang}</div>
                                            <div className="col-md-2">{s.wettbewerb.label}</div>
                                            <div className="col-md-2">{mitStartpass && s.startpass}</div>
                                        </div>
                                    </div>);
                                })}
                            </div>
                        </div>

                        <div className="d-md-none">
                            {sportlerList.map((s, idx) => {
                                return (<div className={"list-group-item" + (idx % 2 === 0 ? " jh-striped" : "")} key={idx}>
                                    <div className="row">
                                        <div className="col-sm-12"><span>{s.vorname} {s.nachname} ({s.geschlecht.label})</span></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">{s.wettbewerb.label}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12 jh-subline">Jahrgang: {s.jahrgang}</div>
                                    </div>
                                    <div className="row" hidden={!mitStartpass}>
                                        <div className="col-sm-12 jh-subline">{mitStartpass && "Startpass: " + s.startpass}</div>
                                    </div>
                                </div>);
                            })}
                        </div>

                        <div className="form-check" style={{ marginTop: "40px" }}>
                            <input className="form-check-input" type="checkbox" checked={this.state.isDatenschutzAccepted} id="checkboxDatenschutz"
                                onChange={this.onDatenschutToggle} disabled={this.state.isSaving} />
                            <label className="form-check-label" htmlFor="checkboxDatenschutz">
                            Ich habe die Hinweise zum Datenschutz gelesen und akzeptiere, dass die angegebenen Daten zur Durchführung der Veranstaltung verwendet werden.
                            </label>
                        </div>

                        <div className="form-check jh-captcha">
                            <ReCAPTCHA
                                sitekey="6Lccw44UAAAAAF1bK2iZ8bXOdiSLW2JDy1QopDSJ"
                                onChange={this.onCaptchaChange}
                                ref={this.recaptchaRef}
                            />
                        </div>

                        <div className="form-row jh-space-top-mid">
                            {this.state.errorMessage != null && <div className="form-group col-md-12"><label style={{ color: "#fe2360" }}>Fehler beim Speichern der Anmeldung: {this.state.errorMessage}</label></div>}

                            <div className="form-group col-md-12">
                                <CenteredLoader isVisible={this.state.isSaving} text="Anmeldungen werden gespeichert..." />

                                {!this.state.isSaving && <button className="btn btn-primary btn-block jh-btn" type="button" onClick={this.onFinish}
                                    disabled={!(this.state.isDatenschutzAccepted && this.state.captcha)}>Anmeldung abschließen</button>}

                            </div>
                        </div>
                    </form>

                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/AnmeldungTrainerSubmit.js